import { constUrlBase } from 'constants/api'
import DSCStock from './components/DSCStock'
import InvestmentPortfolioRight from './components/InvestmentPortfolioRight'
import PersonalDirectory from './components/PersonalDirectory'
import './InvestmentPortfolio.scss'
import { Helmet } from "react-helmet";

export default function InvestmentPortfolio() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{constUrlBase.danh_muc_dau_tu.title}</title>
        <meta name="description" content={constUrlBase.danh_muc_dau_tu.description} />
      </Helmet>
      <div className="klrlhetfnc">
        <div className="ziishjijuo">
          <DSCStock />
          <PersonalDirectory />
        </div>
        <div className="bqjbqckhve">
          <InvestmentPortfolioRight />
        </div>
      </div>
    </>
  )
}